import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  customer: {},
  users: [],
};

const getters = {
  users: data => {
    return data.users;
  },
  customer: data => {
    return data.customer;
  },
};

const actions = {
  save({ commit }, { users }) {
    try {
      commit('save', users);
      return true;
    } catch (e) {
      throw e;
    }
  },
  customer({ commit }, { id }) {
    try {
      commit('customer', id);
      return true;
    } catch (e) {
      throw e;
    }
  },
  update({ commit }, { id, users }) {
    try {
      commit('update customer', id, users);
      return true;
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  save(state, users) {
    state.users = users;
  },
  customer(state, id) {
    state.customer[id] = [];
  },
  update(state, data) {
    state.customer[data.customerId] = data.userList;
  },
  id(state, customer) {
    state.customer = customer;
  }
};



const users = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default users;

export { users };

